import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationsStateSelector } from "../recommendationsStateSelector";

export const recommendationsReadyToDismissSelector = createDraftSafeSelector(
  [recommendationsStateSelector],
  (state) => {
    return state.dismiss.recommendationsReadyToDismiss;
  },
);
